<!--
  If we place the chip inside the badge (as would be usual) an issue appears
  where the group of chips does not center the active one.
-->
<template>
  <div class="pt-2">
    <v-chip>
      <v-icon
        v-if="failed"
        small
        left
        v-text="icons.warning"
      />
      {{ name }}
    </v-chip>
    <v-badge
      :offset-x="count < 10 ? 24 : 28"
      offset-y="-8"
      :content="count"
      :value="showBadge"
    />
  </div>
</template>

<script>
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      UsesIcons,
    ],

    props: {
      index: {
        required: true,
        type: Number,
      },
      name: {
        required: true,
        type: String,
      },
      failed: {
        required: true,
        type: Boolean,
      },
    },

    computed: {
      count () {
        return this.$store.getters['orders/menu/countItemsInCategory'](this.index)
      },
      showBadge () {
        return this.count > 0
      },
    },
  }
</script>
